import { ComponentPropsWithoutRef, forwardRef, isValidElement, memo, ReactElement } from "react"

type SVGProps = ComponentPropsWithoutRef<"svg">

export const Icon0 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM10.265 15.513C10.683 15.821 11.1817 15.975 11.761 15.975C12.333 15.975 12.828 15.8137 13.246 15.491C13.664 15.1683 13.983 14.7063 14.203 14.105C14.4303 13.4963 14.544 12.774 14.544 11.938C14.544 11.102 14.4377 10.3907 14.225 9.804C14.0123 9.21733 13.7007 8.77 13.29 8.462C12.8793 8.154 12.3843 8 11.805 8C11.233 8 10.7343 8.16133 10.309 8.484C9.891 8.80667 9.56833 9.26867 9.341 9.87C9.11367 10.4713 9 11.1827 9 12.004C9 12.8473 9.10633 13.566 9.319 14.16C9.539 14.754 9.85433 15.205 10.265 15.513ZM12.421 14.479C12.245 14.6917 12.0323 14.798 11.783 14.798C11.5263 14.798 11.3063 14.6953 11.123 14.49C10.947 14.2773 10.8113 13.962 10.716 13.544C10.628 13.126 10.584 12.6053 10.584 11.982C10.584 11.3733 10.6317 10.86 10.727 10.442C10.8223 10.024 10.958 9.70867 11.134 9.496C11.31 9.276 11.5263 9.166 11.783 9.166C12.0397 9.166 12.2523 9.27233 12.421 9.485C12.597 9.69767 12.729 10.013 12.817 10.431C12.9123 10.849 12.96 11.3623 12.96 11.971C12.96 12.5943 12.9123 13.115 12.817 13.533C12.729 13.951 12.597 14.2663 12.421 14.479Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon1 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM11.4859 9.70919L9.8689 10.079V8.979L12.1019 8H12.9819V14.49H14.4339V15.7H9.9129V14.49H11.4859V9.70919Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon10 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.625 4.875H4.875V18.625H18.625V4.875ZM4.875 3H18.625H20.5V4.875V18.625V20.5H18.625H4.875H3V18.625V4.875V3H4.875ZM14.2593 15.975C13.68 15.975 13.1813 15.821 12.7633 15.513C12.3526 15.205 12.0373 14.754 11.8173 14.16C11.6046 13.566 11.4983 12.8473 11.4983 12.004C11.4983 11.1827 11.612 10.4713 11.8393 9.87C12.0666 9.26867 12.3893 8.80667 12.8073 8.484C13.2326 8.16133 13.7313 8 14.3033 8C14.8826 8 15.3776 8.154 15.7883 8.462C16.199 8.77 16.5106 9.21733 16.7233 9.804C16.936 10.3907 17.0423 11.102 17.0423 11.938C17.0423 12.774 16.9286 13.4963 16.7013 14.105C16.4813 14.7063 16.1623 15.1683 15.7443 15.491C15.3263 15.8137 14.8313 15.975 14.2593 15.975ZM14.2813 14.798C14.5306 14.798 14.7433 14.6917 14.9193 14.479C15.0953 14.2663 15.2273 13.951 15.3153 13.533C15.4106 13.115 15.4583 12.5943 15.4583 11.971C15.4583 11.3623 15.4106 10.849 15.3153 10.431C15.2273 10.013 15.0953 9.69767 14.9193 9.485C14.7506 9.27233 14.538 9.166 14.2813 9.166C14.0246 9.166 13.8083 9.276 13.6323 9.496C13.4563 9.70867 13.3206 10.024 13.2253 10.442C13.13 10.86 13.0823 11.3733 13.0823 11.982C13.0823 12.6053 13.1263 13.126 13.2143 13.544C13.3096 13.962 13.4453 14.2773 13.6213 14.49C13.8046 14.6953 14.0246 14.798 14.2813 14.798ZM8.4859 9.84127L6.8689 10.2111V9.11108L9.1019 8.13208H9.9819V14.6221H11.4339V15.8321H6.9129V14.6221H8.4859V9.84127Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon12 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.625 4.875H4.875V18.625H18.625V4.875ZM4.875 3H18.625H20.5V4.875V18.625V20.5H18.625H4.875H3V18.625V4.875V3H4.875ZM11.9374 14.831L13.9284 12.642C14.3024 12.2533 14.5884 11.9307 14.7864 11.674C14.9844 11.41 15.1238 11.168 15.2044 10.948C15.2851 10.728 15.3254 10.4897 15.3254 10.233C15.3254 10.0057 15.2814 9.81133 15.1934 9.65C15.1128 9.48867 14.9918 9.364 14.8304 9.276C14.6764 9.188 14.4894 9.144 14.2694 9.144C13.9101 9.144 13.6278 9.24667 13.4224 9.452C13.2171 9.65733 13.0778 9.98367 13.0044 10.431L11.7834 10.167C11.9008 9.43367 12.1794 8.891 12.6194 8.539C13.0594 8.17967 13.6351 8 14.3464 8C14.8671 8 15.3071 8.08433 15.6664 8.253C16.0258 8.42167 16.2971 8.66733 16.4804 8.99C16.6711 9.31267 16.7664 9.70133 16.7664 10.156C16.7664 10.486 16.7114 10.805 16.6014 11.113C16.4914 11.4137 16.3118 11.729 16.0624 12.059C15.8131 12.389 15.4794 12.7593 15.0614 13.17C14.9441 13.2727 14.8561 13.3533 14.7974 13.412L13.647 14.611H16.9314V15.832H11.9374V14.831ZM8.617 9.84127L7 10.2111V9.11108L9.233 8.13208H10.113V14.6221H11.565V15.8321H7.044V14.6221H8.617V9.84127Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon14 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.625 4.875H4.875V18.625H18.625V4.875ZM4.875 3H18.625H20.5V4.875V18.625V20.5H18.625H4.875H3V18.625V4.875V3H4.875ZM11.3884 13.148L14.5234 8H16.1514V12.906H17.0864V14.072H16.1514V15.7H14.7434V14.072H11.3884V13.148ZM12.7752 12.906L14.7434 9.67V12.906H12.7752ZM8.4859 9.70919L6.8689 10.079V8.979L9.1019 8H9.9819V14.49H11.4339V15.7H6.9129V14.49H8.4859V9.70919Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon18 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.625 4.875H4.875V18.625H18.625V4.875ZM4.875 3H18.625H20.5V4.875V18.625V20.5H18.625H4.875H3V18.625V4.875V3H4.875ZM14.3464 15.975C13.8184 15.975 13.3601 15.8943 12.9714 15.733C12.5901 15.5717 12.2968 15.3407 12.0914 15.04C11.8861 14.732 11.7834 14.369 11.7834 13.951C11.7834 13.6357 11.8494 13.3387 11.9814 13.06C12.1208 12.7813 12.3151 12.543 12.5644 12.345C12.7191 12.2177 12.8906 12.1072 13.0791 12.0137C12.9983 11.9648 12.9221 11.9139 12.8504 11.861C12.5424 11.6337 12.3151 11.377 12.1684 11.091C12.0291 10.805 11.9594 10.486 11.9594 10.134C11.9594 9.70133 12.0584 9.32733 12.2564 9.012C12.4544 8.68933 12.7404 8.44 13.1144 8.264C13.4958 8.088 13.9431 8 14.4564 8C14.9551 8 15.3804 8.077 15.7324 8.231C16.0918 8.385 16.3668 8.60867 16.5574 8.902C16.7481 9.19533 16.8434 9.54733 16.8434 9.958C16.8434 10.2367 16.7848 10.497 16.6674 10.739C16.5574 10.981 16.3961 11.201 16.1834 11.399C16.0493 11.5193 15.8962 11.6264 15.7241 11.7204C15.8731 11.7992 16.0078 11.8827 16.1284 11.971C16.4291 12.1837 16.6528 12.4367 16.7994 12.73C16.9461 13.016 17.0194 13.346 17.0194 13.72C17.0194 14.1747 16.9094 14.5707 16.6894 14.908C16.4768 15.2453 16.1688 15.5093 15.7654 15.7C15.3621 15.8833 14.8891 15.975 14.3464 15.975ZM13.9834 10.981C14.1667 11.0865 14.3984 11.1921 14.6784 11.2976C14.818 11.212 14.9383 11.1211 15.0394 11.025C15.1934 10.8857 15.3071 10.7353 15.3804 10.574C15.4538 10.4127 15.4904 10.2403 15.4904 10.057C15.4904 9.771 15.3951 9.54367 15.2044 9.375C15.0138 9.20633 14.7461 9.122 14.4014 9.122C14.1814 9.122 13.9871 9.15867 13.8184 9.232C13.6571 9.30533 13.5324 9.408 13.4444 9.54C13.3638 9.672 13.3234 9.82967 13.3234 10.013C13.3234 10.211 13.3748 10.387 13.4774 10.541C13.5801 10.695 13.7488 10.8417 13.9834 10.981ZM14.1286 12.4673C13.9615 12.554 13.8141 12.6489 13.6864 12.752C13.5031 12.8987 13.3638 13.0637 13.2684 13.247C13.1804 13.4303 13.1364 13.6283 13.1364 13.841C13.1364 14.1563 13.2464 14.4057 13.4664 14.589C13.6938 14.765 14.0018 14.853 14.3904 14.853C14.7864 14.853 15.0944 14.765 15.3144 14.589C15.5344 14.413 15.6444 14.171 15.6444 13.863C15.6444 13.6503 15.5968 13.4633 15.5014 13.302C15.4061 13.1407 15.2411 12.9903 15.0064 12.851C14.7911 12.7231 14.4984 12.5952 14.1286 12.4673ZM8.617 9.84127L7 10.2111V9.11108L9.233 8.13208H10.113V14.6221H11.565V15.8321H7.044V14.6221H8.617V9.84127Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon2 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM11.145 12.642L9.154 14.831V15.832H14.148V14.611H10.8635L12.014 13.412C12.0727 13.3533 12.1607 13.2727 12.278 13.17C12.696 12.7593 13.0297 12.389 13.279 12.059C13.5283 11.729 13.708 11.4137 13.818 11.113C13.928 10.805 13.983 10.486 13.983 10.156C13.983 9.70133 13.8877 9.31267 13.697 8.99C13.5137 8.66733 13.2423 8.42167 12.883 8.253C12.5237 8.08433 12.0837 8 11.563 8C10.8517 8 10.276 8.17967 9.836 8.539C9.396 8.891 9.11733 9.43367 9 10.167L10.221 10.431C10.2943 9.98367 10.4337 9.65733 10.639 9.452C10.8443 9.24667 11.1267 9.144 11.486 9.144C11.706 9.144 11.893 9.188 12.047 9.276C12.2083 9.364 12.3293 9.48867 12.41 9.65C12.498 9.81133 12.542 10.0057 12.542 10.233C12.542 10.4897 12.5017 10.728 12.421 10.948C12.3403 11.168 12.201 11.41 12.003 11.674C11.805 11.9307 11.519 12.2533 11.145 12.642Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon3 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM9.902 15.502C10.3493 15.8173 10.9213 15.975 11.618 15.975C12.1533 15.975 12.619 15.8797 13.015 15.689C13.4183 15.4983 13.73 15.227 13.95 14.875C14.1773 14.5157 14.291 14.0903 14.291 13.599C14.291 13.225 14.225 12.895 14.093 12.609C13.961 12.3157 13.7667 12.0773 13.51 11.894C13.3768 11.796 13.2289 11.7169 13.0664 11.6567C13.1376 11.6145 13.2048 11.569 13.268 11.52C13.5027 11.344 13.6787 11.1277 13.796 10.871C13.9207 10.6143 13.983 10.332 13.983 10.024C13.983 9.59867 13.8913 9.23567 13.708 8.935C13.5247 8.63433 13.257 8.40333 12.905 8.242C12.553 8.08067 12.1277 8 11.629 8C10.8957 8 10.3127 8.18333 9.88 8.55C9.44733 8.90933 9.176 9.43733 9.066 10.134L10.265 10.398C10.331 9.98 10.463 9.66833 10.661 9.463C10.859 9.25033 11.1413 9.144 11.508 9.144C11.7353 9.144 11.926 9.18433 12.08 9.265C12.234 9.34567 12.3477 9.46667 12.421 9.628C12.5017 9.782 12.542 9.97267 12.542 10.2C12.542 10.552 12.4467 10.8233 12.256 11.014C12.0653 11.2047 11.794 11.3 11.442 11.3H10.936V12.477H11.618C12.0067 12.477 12.3037 12.576 12.509 12.774C12.7217 12.9647 12.828 13.2397 12.828 13.599C12.828 13.8557 12.7803 14.0757 12.685 14.259C12.597 14.4423 12.4613 14.5853 12.278 14.688C12.102 14.7833 11.882 14.831 11.618 14.831C11.3833 14.831 11.1743 14.7907 10.991 14.71C10.815 14.622 10.6647 14.4937 10.54 14.325C10.4153 14.149 10.3163 13.929 10.243 13.665L9 14.072C9.154 14.71 9.45467 15.1867 9.902 15.502Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon4 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM12.135 8L9 13.148V14.072H12.355V15.7H13.763V14.072H14.698V12.906H13.763V8H12.135ZM12.355 9.67L10.3868 12.906H12.355V9.67Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon5 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM10.8371 15.645C11.1745 15.777 11.5595 15.843 11.9921 15.843C12.5275 15.843 12.9931 15.7367 13.3891 15.524C13.7851 15.304 14.0931 14.9923 14.3131 14.589C14.5331 14.1857 14.6431 13.7163 14.6431 13.181C14.6431 12.6603 14.5551 12.213 14.3791 11.839C14.2105 11.4577 13.9538 11.168 13.6091 10.97C13.2718 10.772 12.8575 10.673 12.3661 10.673C12.0288 10.673 11.7245 10.7243 11.4531 10.827C11.2679 10.8921 11.0929 10.9845 10.9282 11.1043L11.029 9.254H14.2141V8H9.90212L9.68212 12.158L10.8041 12.499C10.9581 12.2863 11.1341 12.125 11.3321 12.015C11.5301 11.905 11.7648 11.85 12.0361 11.85C12.4101 11.85 12.6925 11.971 12.8831 12.213C13.0811 12.4477 13.1801 12.785 13.1801 13.225C13.1801 13.533 13.1361 13.797 13.0481 14.017C12.9601 14.2297 12.8245 14.3983 12.6411 14.523C12.4651 14.6403 12.2488 14.699 11.9921 14.699C11.6548 14.699 11.3798 14.611 11.1671 14.435C10.9545 14.259 10.8005 13.984 10.7051 13.61L9.49512 13.995C9.59778 14.4203 9.76278 14.7687 9.99012 15.04C10.2175 15.3113 10.4998 15.513 10.8371 15.645Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon6 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM10.276 15.535C10.694 15.8283 11.211 15.975 11.827 15.975C12.3183 15.975 12.7583 15.8687 13.147 15.656C13.543 15.436 13.8473 15.128 14.06 14.732C14.28 14.336 14.39 13.885 14.39 13.379C14.39 12.9097 14.3093 12.499 14.148 12.147C13.9867 11.795 13.7447 11.5237 13.422 11.333C13.1067 11.135 12.7253 11.036 12.278 11.036C11.9847 11.036 11.7097 11.08 11.453 11.168C11.1963 11.256 10.9543 11.3917 10.727 11.575C10.668 11.6222 10.6106 11.6734 10.5547 11.7285C10.5676 11.191 10.614 10.7438 10.694 10.387C10.7967 9.96167 10.9433 9.65367 11.134 9.463C11.3247 9.27233 11.5593 9.177 11.838 9.177C12.014 9.177 12.1643 9.21733 12.289 9.298C12.421 9.37867 12.531 9.50333 12.619 9.672C12.707 9.83333 12.7767 10.035 12.828 10.277L14.126 10.002C14.0747 9.57667 13.95 9.21367 13.752 8.913C13.5613 8.61233 13.3047 8.385 12.982 8.231C12.6593 8.077 12.2817 8 11.849 8C11.2623 8 10.7527 8.16133 10.32 8.484C9.89467 8.79933 9.56833 9.265 9.341 9.881C9.11367 10.497 9 11.2303 9 12.081C9 12.9317 9.10633 13.6467 9.319 14.226C9.539 14.798 9.858 15.2343 10.276 15.535ZM10.5845 12.9184C10.6732 12.7974 10.7647 12.6943 10.859 12.609C11.0203 12.4623 11.1853 12.3597 11.354 12.301C11.5227 12.2423 11.7023 12.213 11.893 12.213C12.1203 12.213 12.311 12.268 12.465 12.378C12.6263 12.4807 12.7473 12.631 12.828 12.829C12.9087 13.0197 12.949 13.247 12.949 13.511C12.949 13.7823 12.905 14.017 12.817 14.215C12.7363 14.413 12.6153 14.567 12.454 14.677C12.3 14.787 12.113 14.842 11.893 14.842C11.585 14.842 11.332 14.7467 11.134 14.556C10.9433 14.3653 10.7967 14.0647 10.694 13.654C10.6448 13.442 10.6083 13.1968 10.5845 12.9184Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon7 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM10.639 13.236C10.4923 14.0133 10.419 14.8347 10.419 15.7H12.014V15.601C12.0213 14.5963 12.0763 13.7273 12.179 12.994C12.289 12.2607 12.498 11.5603 12.806 10.893C13.1213 10.2183 13.5723 9.54733 14.159 8.88V8H9V9.254H12.5261C12.0656 9.79703 11.6896 10.369 11.398 10.97C11.0387 11.7033 10.7857 12.4587 10.639 13.236Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon8 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM10.188 15.733C10.5767 15.8943 11.035 15.975 11.563 15.975C12.1057 15.975 12.5787 15.8833 12.982 15.7C13.3853 15.5093 13.6933 15.2453 13.906 14.908C14.126 14.5707 14.236 14.1747 14.236 13.72C14.236 13.346 14.1627 13.016 14.016 12.73C13.8693 12.4367 13.6457 12.1837 13.345 11.971C13.2244 11.8827 13.0896 11.7992 12.9407 11.7204C13.1128 11.6264 13.2659 11.5193 13.4 11.399C13.6127 11.201 13.774 10.981 13.884 10.739C14.0013 10.497 14.06 10.2367 14.06 9.958C14.06 9.54733 13.9647 9.19533 13.774 8.902C13.5833 8.60867 13.3083 8.385 12.949 8.231C12.597 8.077 12.1717 8 11.673 8C11.1597 8 10.7123 8.088 10.331 8.264C9.957 8.44 9.671 8.68933 9.473 9.012C9.275 9.32733 9.176 9.70133 9.176 10.134C9.176 10.486 9.24567 10.805 9.385 11.091C9.53167 11.377 9.759 11.6337 10.067 11.861C10.1387 11.9139 10.2149 11.9648 10.2957 12.0137C10.1072 12.1072 9.93564 12.2177 9.781 12.345C9.53167 12.543 9.33733 12.7813 9.198 13.06C9.066 13.3387 9 13.6357 9 13.951C9 14.369 9.10267 14.732 9.308 15.04C9.51333 15.3407 9.80667 15.5717 10.188 15.733ZM11.895 11.2976C11.615 11.1921 11.3833 11.0865 11.2 10.981C10.9653 10.8417 10.7967 10.695 10.694 10.541C10.5913 10.387 10.54 10.211 10.54 10.013C10.54 9.82967 10.5803 9.672 10.661 9.54C10.749 9.408 10.8737 9.30533 11.035 9.232C11.2037 9.15867 11.398 9.122 11.618 9.122C11.9627 9.122 12.2303 9.20633 12.421 9.375C12.6117 9.54367 12.707 9.771 12.707 10.057C12.707 10.2403 12.6703 10.4127 12.597 10.574C12.5237 10.7353 12.41 10.8857 12.256 11.025C12.1548 11.1211 12.0345 11.212 11.895 11.2976ZM10.903 12.752C11.0307 12.6489 11.178 12.554 11.3451 12.4673C11.715 12.5952 12.0076 12.7231 12.223 12.851C12.4577 12.9903 12.6227 13.1407 12.718 13.302C12.8133 13.4633 12.861 13.6503 12.861 13.863C12.861 14.171 12.751 14.413 12.531 14.589C12.311 14.765 12.003 14.853 11.607 14.853C11.2183 14.853 10.9103 14.765 10.683 14.589C10.463 14.4057 10.353 14.1563 10.353 13.841C10.353 13.6283 10.397 13.4303 10.485 13.247C10.5803 13.0637 10.7197 12.8987 10.903 12.752Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const Icon9 = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.875 4.875H18.625V18.625H4.875V4.875ZM18.625 3H4.875H3V4.875V18.625V20.5H4.875H18.625H20.5V18.625V4.875V3H18.625ZM10.397 15.744C10.7343 15.898 11.1193 15.975 11.552 15.975C12.146 15.975 12.652 15.821 13.07 15.513C13.4953 15.205 13.818 14.7503 14.038 14.149C14.258 13.5403 14.368 12.796 14.368 11.916C14.368 11.0727 14.258 10.3613 14.038 9.782C13.818 9.19533 13.4953 8.75167 13.07 8.451C12.652 8.15033 12.1423 8 11.541 8C11.035 8 10.5877 8.11 10.199 8.33C9.81767 8.54267 9.52067 8.847 9.308 9.243C9.10267 9.63167 9 10.0863 9 10.607C9 11.0837 9.08433 11.5053 9.253 11.872C9.42167 12.2313 9.66367 12.51 9.979 12.708C10.3017 12.906 10.6867 13.005 11.134 13.005C11.5667 13.005 11.9443 12.9243 12.267 12.763C12.4659 12.659 12.648 12.5244 12.8135 12.3592C12.8008 12.8971 12.7544 13.3361 12.674 13.676C12.586 14.072 12.4503 14.3617 12.267 14.545C12.091 14.721 11.8563 14.809 11.563 14.809C11.277 14.809 11.0423 14.721 10.859 14.545C10.683 14.3617 10.5547 14.0793 10.474 13.698L9.154 13.984C9.22 14.4093 9.35933 14.7723 9.572 15.073C9.78467 15.3663 10.0597 15.59 10.397 15.744ZM12.7842 11.1963C12.6342 11.4093 12.4654 11.5686 12.278 11.674C12.0507 11.7987 11.794 11.861 11.508 11.861C11.2807 11.861 11.0863 11.8097 10.925 11.707C10.771 11.597 10.6537 11.4393 10.573 11.234C10.4923 11.0213 10.452 10.772 10.452 10.486C10.452 10.2073 10.4923 9.969 10.573 9.771C10.6537 9.56567 10.7747 9.41167 10.936 9.309C11.0973 9.199 11.288 9.144 11.508 9.144C11.8013 9.144 12.0433 9.254 12.234 9.474C12.432 9.68667 12.5787 10.0093 12.674 10.442C12.7237 10.6636 12.7604 10.915 12.7842 11.1963Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconArrowLeft = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M3.70312 12.9688L3.03906 12.3047L3.70312 11.6406L9.67969 5.66406L10.3438 5L11.6719 6.32812L11.0078 6.99219L6.63281 11.3672H19.5625H20.5V13.2422H19.5625H6.63281L11.0078 17.6562L11.6719 18.3203L10.3438 19.6484L9.67969 18.9844L3.70312 12.9688Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconArrowRight = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M19.7578 12.9688L13.7812 18.9844L13.1172 19.6484L11.7891 18.3203L12.4531 17.6562L16.8281 13.2422H3.9375H3V11.3672H3.9375H16.8281L12.4531 6.99219L11.7891 6.32812L13.1172 5L13.7812 5.66406L19.7578 11.6406L20.4219 12.3047L19.7578 12.9688Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconBookmark = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M11.5 14.9766L12.4375 15.5234L17.125 18.2578V3.375H5.875V18.2578L10.5234 15.5234L11.5 14.9766ZM5.875 20.4062L4 21.5V19.3516V3.375V1.5H5.875H17.125H19V3.375V19.3516V21.5L17.125 20.4062L11.5 17.125L5.875 20.4062Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconCalendar = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M8.9375 2.4375V4H14.5625V2.4375V1.5H16.4375V2.4375V4H20.5V7.125V9V19.625V21.5H18.625H4.875H3V19.625V9V7.125V4H7.0625V2.4375V1.5H8.9375V2.4375ZM4.875 9V19.625H18.625V9H4.875Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconCart = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M1.9375 2.5H4.75H5.49219L5.64844 3.28125L5.76562 3.75H21.5078H23.5L22.9141 5.625L20.375 13.75H7.64062L7.99219 15.625H20.0625H21V17.5H20.0625H7.25H6.46875L6.3125 16.7578L3.96875 4.375H1.9375H1V2.5H1.9375ZM7.28906 11.875H18.9688L20.9219 5.625H6.11719L7.28906 11.875ZM7.875 22.5C7.17188 22.5 6.58594 22.1484 6.23438 21.5625C5.88281 21.0156 5.88281 20.2734 6.23438 19.6875C6.58594 19.1406 7.17188 18.75 7.875 18.75C8.53906 18.75 9.125 19.1406 9.47656 19.6875C9.82812 20.2734 9.82812 21.0156 9.47656 21.5625C9.125 22.1484 8.53906 22.5 7.875 22.5ZM21 20.625C21 21.3281 20.6094 21.9141 20.0625 22.2656C19.4766 22.6172 18.7344 22.6172 18.1875 22.2656C17.6016 21.9141 17.25 21.3281 17.25 20.625C17.25 19.9609 17.6016 19.375 18.1875 19.0234C18.7344 18.6719 19.4766 18.6719 20.0625 19.0234C20.6094 19.375 21 19.9609 21 20.625Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconCheck = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M20.5 6.57812L19.8359 7.24219L9.91406 17.125L9.25 17.7891L8.58594 17.125L3.66406 12.2031L3 11.5391L4.28906 10.2109L4.95312 10.875L9.25 15.1328L18.5078 5.91406L19.1719 5.25L20.5 6.57812Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconChevronDown = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M12.6387 16.3359L11.9746 17L11.3105 16.3359L5.33398 10.3594L4.66992 9.69531L5.99805 8.36719L6.66211 9.03125L11.9746 14.3437L17.3262 9.03125L17.9902 8.36719L19.3184 9.69531L18.6543 10.3594L12.6387 16.3359Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconChevronLeft = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M7.66406 12.6187L7 11.9546L7.66406 11.2905L13.6406 5.31396L14.3047 4.6499L15.6328 5.97803L14.9688 6.64209L9.65625 11.9546L14.9687 17.3062L15.6328 17.9702L14.3047 19.2983L13.6406 18.6343L7.66406 12.6187Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconChevronRight = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M16.3359 11.3296L17 11.9937L16.3359 12.6577L10.3594 18.6343L9.69531 19.2983L8.36719 17.9702L9.03125 17.3062L14.3438 11.9937L9.03125 6.64209L8.36719 5.97803L9.69531 4.6499L10.3594 5.31396L16.3359 11.3296Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconChevronUp = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M11.3496 8.66406L12.0137 8L12.6777 8.66406L18.6543 14.6406L19.3184 15.3047L17.9902 16.6328L17.3262 15.9687L12.0137 10.6562L6.66211 15.9687L5.99805 16.6328L4.66992 15.3047L5.33398 14.6406L11.3496 8.66406Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconClose = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M7.41608 5.99991L18.0227 16.6065L16.6085 18.0207L6.00187 7.41412L7.41608 5.99991Z"
          fill="currentColor"
        ></path>
        <path
          d="M18.0215 7.41397L7.41495 18.0206L6.00073 16.6064L16.6073 5.99976L18.0215 7.41397Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconDownload = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.46973 12.6554L8.53039 11.5947L12.0001 15.0644L15.4697 11.5947L16.5304 12.6554L12.0001 17.1857L7.46973 12.6554Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.75 6.125V16.125H11.25V6.125H12.75Z"
          fill="currentColor"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.25 0.875H22.75V22.375H1.25V0.875ZM2.75 2.375V20.875H21.25V2.375H2.75Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconHamburger = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M3 5H20.5V6.875H3V5ZM3 11.25H20.5V13.125H3V11.25ZM20.5 17.5V19.375H3V17.5H20.5Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconInfo = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M18.625 4.875H4.875V18.625H18.625V4.875ZM4.875 3H18.625H20.5V4.875V18.625V20.5H18.625H4.875H3V18.625V4.875V3H4.875Z"
          fill="currentColor"
        ></path>
        <path d="M11.028 9.786H12.736V16.8H11.028V9.786ZM11 7H12.75V8.652H11V7Z" fill="currentColor"></path>
      </svg>
    )
  }),
)

export const IconLocation = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M17.125 9.5C17.125 6.41406 14.5859 3.875 11.5 3.875C8.375 3.875 5.875 6.41406 5.875 9.5C5.875 10.1641 6.14844 11.1406 6.8125 12.4688C7.47656 13.7188 8.33594 15.0469 9.23438 16.2969C10.0547 17.3906 10.8359 18.3672 11.5 19.1484C12.125 18.3672 12.9062 17.3906 13.7266 16.2969C14.625 15.0469 15.4844 13.7188 16.1484 12.4688C16.8125 11.1406 17.125 10.1641 17.125 9.5ZM19 9.5C19 12.7812 14.8594 18.0547 12.7109 20.5938C11.9688 21.4922 11.5 22 11.5 22C11.5 22 10.9922 21.4922 10.25 20.5938C8.10156 18.0547 4 12.7812 4 9.5C4 5.35938 7.35938 2 11.5 2C15.6406 2 19 5.35938 19 9.5ZM12.75 9.5C12.75 8.83594 12.1641 8.25 11.5 8.25C10.7969 8.25 10.25 8.83594 10.25 9.5C10.25 10.2031 10.7969 10.75 11.5 10.75C12.1641 10.75 12.75 10.2031 12.75 9.5ZM8.375 9.5C8.375 8.40625 8.96094 7.39062 9.9375 6.80469C10.875 6.25781 12.0859 6.25781 13.0625 6.80469C14 7.39062 14.625 8.40625 14.625 9.5C14.625 10.6328 14 11.6484 13.0625 12.2344C12.0859 12.7812 10.875 12.7812 9.9375 12.2344C8.96094 11.6484 8.375 10.6328 8.375 9.5Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconPlaceholder = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <circle cx="12" cy="12" r="7" fill="currentColor"></circle>
      </svg>
    )
  }),
)

export const IconPlay = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M5 3L6.875 4.09375L18.125 10.6953L20 11.75L18.125 12.8438L6.875 19.4062L5 20.5V18.3516V5.1875V3ZM6.875 6.28125V17.2578L16.25 11.75L6.875 6.28125Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconAdd = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M13.0625 4.9375V11.1875H19.3125H20.25V13.0625H19.3125H13.0625V19.3125V20.25H11.1875V19.3125V13.0625H4.9375H4V11.1875H4.9375H11.1875V4.9375V4H13.0625V4.9375Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconAccount = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M14.875 6.5C14.875 5.40625 14.25 4.39062 13.3125 3.80469C12.3359 3.25781 11.125 3.25781 10.1875 3.80469C9.21094 4.39062 8.625 5.40625 8.625 6.5C8.625 7.63281 9.21094 8.64844 10.1875 9.23438C11.125 9.78125 12.3359 9.78125 13.3125 9.23438C14.25 8.64844 14.875 7.63281 14.875 6.5ZM6.75 6.5C6.75 4.74219 7.6875 3.10156 9.25 2.20312C10.7734 1.30469 12.6875 1.30469 14.25 2.20312C15.7734 3.10156 16.75 4.74219 16.75 6.5C16.75 8.29688 15.7734 9.9375 14.25 10.8359C12.6875 11.7344 10.7734 11.7344 9.25 10.8359C7.6875 9.9375 6.75 8.29688 6.75 6.5ZM5.53906 19.625H17.9609L16.5938 15.25H6.86719L5.53906 19.625ZM5.5 13.375H18L19.9141 19.625L20.5 21.5H18.5078H4.95312H3L3.54688 19.625L5.5 13.375Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconSearch = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          d="M16.375 10.625C16.375 8.39844 15.1641 6.36719 13.25 5.23438C11.2969 4.10156 8.91406 4.10156 7 5.23438C5.04688 6.36719 3.875 8.39844 3.875 10.625C3.875 12.8906 5.04688 14.9219 7 16.0547C8.91406 17.1875 11.2969 17.1875 13.25 16.0547C15.1641 14.9219 16.375 12.8906 16.375 10.625ZM15.1641 17.0312C13.7578 18.125 12 18.75 10.125 18.75C5.63281 18.75 2 15.1172 2 10.625C2 6.17188 5.63281 2.5 10.125 2.5C14.5781 2.5 18.25 6.17188 18.25 10.625C18.25 12.5391 17.5859 14.2969 16.4922 15.7031L21.3359 20.5469L22 21.2109L20.6719 22.5L20.0078 21.8359L15.1641 16.9922V17.0312Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconSelectNo = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconSelectYes = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z"
          fill="currentColor"
        ></path>
        <path
          d="M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconTicket = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" {...props} ref={ref}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5987 5.5C14.0799 6.3967 13.1104 7 12 7C10.8896 7 9.92006 6.3967 9.40135 5.5H7.5V18.5H9.40135C9.92006 17.6033 10.8896 17 12 17C13.1104 17 14.0799 17.6033 14.5987 18.5H16.5V5.5H14.5987ZM13.5 20C13.5 19.1716 12.8284 18.5 12 18.5C11.1716 18.5 10.5 19.1716 10.5 20H6V4H10.5C10.5 4.82843 11.1716 5.5 12 5.5C12.8284 5.5 13.5 4.82843 13.5 4H18V20H13.5Z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }),
)

export const IconPeopleTripleArrows = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M17.0156 25.9678C17.0156 26.3597 17.0928 26.7478 17.2428 27.1098C17.3928 27.4719 17.6126 27.8009 17.8897 28.078C18.1669 28.3552 18.4958 28.575 18.8579 28.725C19.22 28.875 19.6081 28.9521 20 28.9521C20.3919 28.9521 20.78 28.875 21.1421 28.725C21.5042 28.575 21.8331 28.3552 22.1103 28.078C22.3874 27.8009 22.6072 27.4719 22.7572 27.1098C22.9072 26.7478 22.9844 26.3597 22.9844 25.9678C22.9844 25.5759 22.9072 25.1878 22.7572 24.8257C22.6072 24.4636 22.3874 24.1346 22.1103 23.8575C21.8331 23.5804 21.5042 23.3605 21.1421 23.2106C20.78 23.0606 20.3919 22.9834 20 22.9834C19.6081 22.9834 19.22 23.0606 18.8579 23.2106C18.4958 23.3605 18.1669 23.5804 17.8897 23.8575C17.6126 24.1346 17.3928 24.4636 17.2428 24.8257C17.0928 25.1878 17.0156 25.5759 17.0156 25.9678Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M28.9531 25.9678C28.9531 26.7593 29.2675 27.5184 29.8272 28.078C30.3869 28.6377 31.146 28.9521 31.9375 28.9521C32.729 28.9521 33.4881 28.6377 34.0478 28.078C34.6075 27.5184 34.9219 26.7593 34.9219 25.9678C34.9219 25.1763 34.6075 24.4172 34.0478 23.8575C33.4881 23.2978 32.729 22.9834 31.9375 22.9834C31.146 22.9834 30.3869 23.2978 29.8272 23.8575C29.2675 24.4172 28.9531 25.1763 28.9531 25.9678Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M3.59375 36.4073C3.59375 35.2221 4.06456 34.0854 4.90262 33.2474C5.74067 32.4093 6.87731 31.9385 8.0625 31.9385C8.65066 31.9364 9.23344 32.0505 9.77741 32.2742C10.3214 32.4978 10.8159 32.8267 11.2325 33.2418C11.6491 33.657 11.9797 34.1503 12.2052 34.6935C12.4308 35.2367 12.5469 35.8191 12.5469 36.4073"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M27.4531 36.4073C27.4531 35.8191 27.5692 35.2367 27.7948 34.6935C28.0203 34.1503 28.3509 33.657 28.7675 33.2418C29.1841 32.8267 29.6786 32.4978 30.2226 32.2742C30.7666 32.0505 31.3493 31.9364 31.9375 31.9385C33.1227 31.9385 34.2593 32.4093 35.0974 33.2474C35.9354 34.0854 36.4062 35.2221 36.4062 36.4073"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M5.07812 25.9678C5.07813 26.7593 5.39255 27.5184 5.95223 28.078C6.51191 28.6377 7.27099 28.9521 8.0625 28.9521C8.85401 28.9521 9.61309 28.6377 10.1728 28.078C10.7325 27.5184 11.0469 26.7593 11.0469 25.9678C11.0469 25.1763 10.7325 24.4172 10.1728 23.8575C9.61309 23.2978 8.85401 22.9834 8.0625 22.9834C7.27099 22.9834 6.51191 23.2978 5.95223 23.8575C5.39255 24.4172 5.07813 25.1763 5.07812 25.9678Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M24.4688 36.4072C24.4688 35.222 23.9979 34.0854 23.1599 33.2473C22.3218 32.4093 21.1852 31.9385 20 31.9385C18.8148 31.9385 17.6782 32.4093 16.8401 33.2473C16.0021 34.0854 15.5313 35.222 15.5312 36.4072"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path d="M15.5312 8.0625L20 3.59375L24.4688 8.0625" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
        <path
          d="M30.4375 8.06152L34.9219 12.5459L30.4375 17.0146"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path d="M20 20V3.59375" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
        <path
          d="M34.9219 12.5464H28.9531C27.7665 12.5464 26.6282 13.0167 25.7877 13.8543C24.9472 14.6919 24.4729 15.8285 24.4688 17.0151V21.562"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M9.5625 8.06152L5.09375 12.5459L9.5625 17.0146"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M5.07812 12.5464H11.0469C12.2335 12.5464 13.3718 13.0167 14.2123 13.8543C15.0528 14.6919 15.5271 15.8285 15.5313 17.0151V21.562"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
    )
  }),
)

export const IconDiagram = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M8.0625 15.5322H8.07812C8.07812 15.5322 12.5469 15.5322 12.5469 20.001V20.0166C12.5469 20.0166 12.5469 24.4854 8.07812 24.4854H8.0625C8.0625 24.4854 3.59375 24.4854 3.59375 20.0166V20.001C3.59375 20.001 3.59375 15.5322 8.0625 15.5322Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M30.4375 3.59375H36.4062V9.5625H30.4375V3.59375Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M30.4375 17.0166H36.4062V22.9854H30.4375V17.0166Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M30.4375 30.437H36.4062V36.4058H30.4375V30.437Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M30.4375 33.4209H21.5V6.57715H30.4375"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path d="M30.4375 20H12.5469" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
      </svg>
    )
  }),
)

export const IconHandsDiamond = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M20 37.9683V29.3745C19.9882 28.2013 19.517 27.0794 18.6875 26.2495L14.6406 22.1402C14.0764 21.5838 13.3158 21.272 12.5234 21.272C11.7311 21.272 10.9705 21.5838 10.4062 22.1402C9.85527 22.7116 9.54242 23.4714 9.53125 24.2652C9.53643 25.3862 9.98595 26.4594 10.7812 27.2495L14.0156 30.4995"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M9.53129 37.9691V36.4066L4.84379 31.7191C4.01432 30.8893 3.54312 29.7674 3.53129 28.5941V17.0472C3.52916 16.6521 3.60594 16.2605 3.75713 15.8954C3.90832 15.5303 4.13087 15.1991 4.41174 14.9211C4.69261 14.6432 5.02614 14.4241 5.39279 14.2767C5.75943 14.1293 6.15181 14.0566 6.54692 14.0629C6.93941 14.0608 7.32842 14.1366 7.69143 14.2858C8.05445 14.4351 8.38427 14.6548 8.66181 14.9324C8.93935 15.2099 9.15909 15.5397 9.30834 15.9027C9.45759 16.2657 9.53336 16.6548 9.53129 17.0472V26.016L14.0157 30.5004"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M20 37.9693V29.3755C20.0118 28.2022 20.483 27.0804 21.3125 26.2505L25.3594 22.2036C25.9236 21.6473 26.6842 21.3354 27.4766 21.3354C28.2689 21.3354 29.0295 21.6473 29.5937 22.2036C30.1447 22.7751 30.4576 23.5349 30.4688 24.3286C30.4636 25.4497 30.014 26.5229 29.2188 27.313L25.9844 30.563"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M30.4687 37.9691V36.4066L35.1562 31.7191C35.9857 30.8893 36.4569 29.7674 36.4687 28.5941V17.0472C36.4709 16.6521 36.3941 16.2605 36.2429 15.8954C36.0917 15.5303 35.8692 15.1991 35.5883 14.9211C35.3074 14.6432 34.9739 14.4241 34.6073 14.2767C34.2406 14.1293 33.8482 14.0566 33.4531 14.0629C33.0606 14.0608 32.6716 14.1366 32.3086 14.2858C31.9456 14.4351 31.6158 14.6548 31.3382 14.9324C31.0607 15.2099 30.8409 15.5397 30.6917 15.9027C30.5425 16.2657 30.4667 16.6548 30.4687 17.0472V26.016L25.9844 30.5004"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M28.9687 8.07813L20 18.5312L11.0312 8.07813L14.0156 3.59375H25.9844L28.9687 8.07813Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
    )
  }),
)

export const IconAccountArrows = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M6.57812 26.7495C6.57812 27.7399 6.97157 28.6898 7.6719 29.3901C8.37223 30.0904 9.32208 30.4839 10.3125 30.4839C11.3029 30.4839 12.2528 30.0904 12.9531 29.3901C13.6534 28.6898 14.0469 27.7399 14.0469 26.7495C14.0469 25.7591 13.6534 24.8092 12.9531 24.1089C12.2528 23.4086 11.3029 23.0151 10.3125 23.0151C9.32208 23.0151 8.37223 23.4086 7.6719 24.1089C6.97157 24.8092 6.57813 25.7591 6.57812 26.7495Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M3.59375 37.9375V37.1875C3.59375 35.4056 4.30162 33.6966 5.56163 32.4366C6.82164 31.1766 8.53058 30.4688 10.3125 30.4688C12.0917 30.4729 13.7966 31.1826 15.0533 32.4421C16.3099 33.7017 17.0156 35.4083 17.0156 37.1875V37.9375"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M25.9531 7.35986C25.9531 8.35028 26.3466 9.30013 27.0469 10.0005C27.7472 10.7008 28.6971 11.0942 29.6875 11.0942C30.6779 11.0942 31.6278 10.7008 32.3281 10.0005C33.0284 9.30013 33.4219 8.35028 33.4219 7.35986C33.4219 6.36945 33.0284 5.41959 32.3281 4.71926C31.6278 4.01893 30.6779 3.62549 29.6875 3.62549C28.6971 3.62549 27.7472 4.01893 27.0469 4.71926C26.3466 5.41959 25.9531 6.36945 25.9531 7.35986Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M22.9844 18.5469V17.7969C22.9844 16.0191 23.6906 14.3141 24.9477 13.0571C26.2048 11.8 27.9097 11.0938 29.6875 11.0938C30.5691 11.0917 31.4424 11.2636 32.2575 11.5995C33.0725 11.9355 33.8133 12.4289 34.4374 13.0515C35.0615 13.6742 35.5567 14.4138 35.8945 15.2281C36.2324 16.0424 36.4063 16.9153 36.4062 17.7969V18.5469"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M25.7812 25.8125L30.4375 21.1719L35.0938 25.8125"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M30.4375 21.5625V26.0313C30.4294 28.3869 29.4932 30.6444 27.8319 32.3145C26.1706 33.9845 23.918 34.9326 21.5625 34.9531"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M14.2187 14.2505L9.5625 18.9067L4.90625 14.2505"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M9.5625 18.5464V14.062C9.5625 12.887 9.79419 11.7235 10.2443 10.6382C10.6944 9.55281 11.3542 8.56686 12.1858 7.73673C13.0173 6.9066 14.0044 6.24859 15.0906 5.80036C16.1767 5.35213 17.3406 5.12247 18.5156 5.12453"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
    )
  }),
)

export const IconPhone = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M12.5469 3.59375H27.4531C27.4531 3.59375 30.4375 3.59375 30.4375 6.57812V33.4219C30.4375 33.4219 30.4375 36.4062 27.4531 36.4062H12.5469C12.5469 36.4062 9.5625 36.4062 9.5625 33.4219V6.57812C9.5625 6.57812 9.5625 3.59375 12.5469 3.59375Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M15.5312 3.59375H24.4844V5.15625C24.4844 5.57065 24.3198 5.96808 24.0267 6.2611C23.7337 6.55413 23.3363 6.71875 22.9219 6.71875H17.0156C16.6012 6.71875 16.2038 6.55413 15.9108 6.2611C15.6177 5.96808 15.4531 5.57065 15.4531 5.15625V3.59375H15.5312Z"
          fill="#26231B"
        />
        <path d="M18.5156 31.9385H21.4844" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
      </svg>
    )
  }),
)

export const IconChat = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M28.9688 27.501C28.9688 28.2925 29.2832 29.0516 29.8429 29.6112C30.4025 30.1709 31.1616 30.4854 31.9531 30.4854C32.7446 30.4854 33.5037 30.1709 34.0634 29.6112C34.6231 29.0516 34.9375 28.2925 34.9375 27.501C34.9375 26.7095 34.6231 25.9504 34.0634 25.3907C33.5037 24.831 32.7446 24.5166 31.9531 24.5166C31.1616 24.5166 30.4025 24.831 29.8429 25.3907C29.2832 25.9504 28.9688 26.7095 28.9688 27.501Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M3.5625 37.9683C3.5625 36.7789 4.03496 35.6383 4.87594 34.7973C5.71693 33.9563 6.85754 33.4839 8.04688 33.4839C9.23494 33.488 10.3732 33.9618 11.2133 34.8019C12.0533 35.642 12.5271 36.7802 12.5312 37.9683"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M27.4688 37.9683C27.4729 36.7802 27.9466 35.642 28.7867 34.8019C29.6268 33.9618 30.7651 33.488 31.9531 33.4839C33.1425 33.4839 34.2831 33.9563 35.1241 34.7973C35.965 35.6383 36.4375 36.7789 36.4375 37.9683"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M5.0625 27.501C5.0625 28.2925 5.37692 29.0516 5.9366 29.6112C6.49628 30.1709 7.25537 30.4854 8.04688 30.4854C8.83838 30.4854 9.59747 30.1709 10.1571 29.6112C10.7168 29.0516 11.0312 28.2925 11.0312 27.501C11.0312 26.7095 10.7168 25.9504 10.1571 25.3907C9.59747 24.831 8.83838 24.5166 8.04688 24.5166C7.25537 24.5166 6.49628 24.831 5.9366 25.3907C5.37692 25.9504 5.0625 26.7095 5.0625 27.501Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M24.4844 8.07861H30.4687V17.0474V18.5317L25.9844 17.0474H15.5156V12.563"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M24.4844 3.59375V12.5625H14.0156L9.53125 14.0625V12.5625V3.59375H24.4844Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
    )
  }),
)

export const IconWirelessRouter = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M6.57812 23.0469H33.4219C33.4219 23.0469 36.4062 23.0469 36.4062 26.0313V32C36.4062 32 36.4062 34.9844 33.4219 34.9844H6.57812C6.57812 34.9844 3.59375 34.9844 3.59375 32V26.0313C3.59375 26.0313 3.59375 23.0469 6.57812 23.0469Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path d="M8.0625 37.9697V34.9854" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M31.9375 37.9697V34.9854" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
        <path
          d="M8.07812 29.0161C8.07813 29.4098 8.23451 29.7874 8.51289 30.0657C8.79126 30.3441 9.16882 30.5005 9.5625 30.5005C9.95618 30.5005 10.3337 30.3441 10.6121 30.0657C10.8905 29.7874 11.0469 29.4098 11.0469 29.0161C11.0469 28.6224 10.8905 28.2449 10.6121 27.9665C10.3337 27.6881 9.95618 27.5317 9.5625 27.5317C9.16882 27.5317 8.79126 27.6881 8.51289 27.9665C8.23451 28.2449 8.07812 28.6224 8.07812 29.0161Z"
          fill="#26231B"
        />
        <path d="M17.0156 29.0161H20" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M22.9844 29.0161H25.9687" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M28.9531 29.0161H31.9375" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
        <path
          d="M18.5156 17.0947C18.5156 17.2897 18.554 17.4827 18.6286 17.6628C18.7032 17.8429 18.8126 18.0065 18.9504 18.1443C19.0882 18.2822 19.2519 18.3915 19.432 18.4661C19.612 18.5407 19.8051 18.5791 20 18.5791C20.1949 18.5791 20.388 18.5407 20.568 18.4661C20.7481 18.3915 20.9118 18.2822 21.0496 18.1443C21.1874 18.0065 21.2968 17.8429 21.3714 17.6628C21.446 17.4827 21.4844 17.2897 21.4844 17.0947C21.4844 16.8998 21.446 16.7068 21.3714 16.5267C21.2968 16.3466 21.1874 16.183 21.0496 16.0451C20.9118 15.9073 20.7481 15.7979 20.568 15.7233C20.388 15.6487 20.1949 15.6104 20 15.6104C19.8051 15.6104 19.612 15.6487 19.432 15.7233C19.2519 15.7979 19.0882 15.9073 18.9504 16.0451C18.8126 16.183 18.7032 16.3466 18.6286 16.5267C18.554 16.7068 18.5156 16.8998 18.5156 17.0947Z"
          fill="#26231B"
        />
        <path
          d="M15.7812 12.8743C16.9005 11.7561 18.4179 11.1279 20 11.1279C21.5821 11.1279 23.0995 11.7561 24.2188 12.8743"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M11.5625 8.65718C12.6688 7.54602 13.9836 6.66432 15.4316 6.0627C16.8795 5.46107 18.432 5.15137 20 5.15137C21.568 5.15137 23.1205 5.46107 24.5684 6.0627C26.0164 6.66432 27.3312 7.54602 28.4375 8.65718"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
    )
  }),
)

export const IconComputerMonitor = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path d="M14.0312 36.4058L15.5312 28.9526" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M9.5625 36.4062H30.4375" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
        <path
          d="M6.57812 3.59375H33.4219C33.4219 3.59375 36.4062 3.59375 36.4062 6.57812V25.9687C36.4062 25.9687 36.4062 28.9531 33.4219 28.9531H6.57812C6.57812 28.9531 3.59375 28.9531 3.59375 25.9687V6.57812C3.59375 6.57812 3.59375 3.59375 6.57812 3.59375Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path d="M25.8594 36.4058L24.375 28.9526" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M3.59375 22.9834H36.4062" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
      </svg>
    )
  }),
)

export const IconChessPiece = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M25.9687 12.5469H14.0313C13.241 12.5428 12.4843 12.227 11.9255 11.6682C11.3667 11.1094 11.051 10.3527 11.0469 9.5625V3.59375H28.9531V9.5625C28.949 10.3527 28.6333 11.1094 28.0745 11.6682C27.5157 12.227 26.759 12.5428 25.9687 12.5469Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M14.0313 28.9526H25.9687C26.7603 28.9526 27.5193 29.2671 28.079 29.8267C28.6387 30.3864 28.9531 31.1455 28.9531 31.937V36.4058H11.0469V31.937C11.0469 31.1455 11.3613 30.3864 11.921 29.8267C12.4807 29.2671 13.2397 28.9526 14.0313 28.9526Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M25.9687 28.9526H14.0312L15.5312 12.5464H24.4688L25.9687 28.9526Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path d="M17.0156 8.0625V3.59375" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M22.9844 8.0625V3.59375" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
      </svg>
    )
  }),
)

export const IconHandPlant = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M11.0631 36.3901H22.8756C23.8542 36.3915 24.8235 36.1989 25.7273 35.8234C26.6311 35.4479 27.4516 34.897 28.1412 34.2026L35.5006 26.8432C35.7987 26.547 36.034 26.1936 36.1924 25.8043C36.3508 25.4151 36.429 24.9978 36.4224 24.5776C36.4327 23.9484 36.2528 23.3307 35.9063 22.8054C35.5597 22.2801 35.0626 21.8717 34.4801 21.6336C33.8976 21.3956 33.2567 21.3389 32.6414 21.4711C32.0262 21.6033 31.4652 21.9181 31.0318 22.3745L22.9849 30.4213H21.5631C21.9962 30.423 22.4244 30.3298 22.8177 30.1484C23.211 29.967 23.5598 29.7017 23.8397 29.3712C24.1196 29.0406 24.3238 28.6529 24.438 28.2351C24.5522 27.8173 24.5735 27.3795 24.5006 26.9526C24.3513 26.239 23.9572 25.6 23.3865 25.1463C22.8158 24.6927 22.1044 24.4528 21.3756 24.4682H15.5318L14.0787 23.7495C12.8321 23.1282 11.4336 22.8774 10.0488 23.027C8.66411 23.1765 7.35132 23.7201 6.26618 24.5932C5.4291 25.2768 4.75695 26.1404 4.29977 27.1197C3.84258 28.099 3.61213 29.1688 3.62555 30.2495V30.4213"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path d="M21.4844 30.4224H14.0469" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
        <path
          d="M9.57813 3.6084H12.5469C13.5256 3.6084 14.4948 3.80118 15.3991 4.17573C16.3033 4.55029 17.1249 5.09928 17.817 5.79137C18.5091 6.48345 19.0581 7.30508 19.4327 8.20934C19.8072 9.11359 20 10.0828 20 11.0615H17.0156C15.0416 11.0574 13.1499 10.2703 11.7556 8.87304C10.3612 7.47575 9.57812 5.58239 9.57813 3.6084Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M22.9844 12.5459H20C20 10.5692 20.7852 8.67348 22.183 7.27574C23.5807 5.87801 25.4764 5.09277 27.4531 5.09277H30.4375C30.4375 7.06947 29.6523 8.9652 28.2545 10.3629C26.8568 11.7607 24.9611 12.5459 22.9844 12.5459Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path d="M20 24.4683V11.062" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
      </svg>
    )
  }),
)

export const IconPuzzle = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M16.4062 10.4375C16.1262 10.7123 15.9045 11.0408 15.7541 11.4032C15.6038 11.7656 15.528 12.1545 15.5313 12.5469C15.5354 13.3371 15.8511 14.0938 16.4099 14.6526C16.9687 15.2114 17.7254 15.5271 18.5156 15.5313H20V20H15.5313V21.5625C15.5313 22.354 15.2168 23.1131 14.6571 23.6728C14.0975 24.2325 13.3384 24.5469 12.5469 24.5469C11.7554 24.5469 10.9963 24.2325 10.4366 23.6728C9.87692 23.1131 9.5625 22.354 9.5625 21.5625V20H3.59375V3.59375H20V9.5625H18.5156C18.1233 9.55925 17.7343 9.63506 17.3719 9.78539C17.0095 9.93572 16.6811 10.1575 16.4062 10.4375Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M36.4063 3.59375V20H30.4375V18.5156C30.4375 17.7241 30.1231 16.965 29.5634 16.4054C29.0037 15.8457 28.2446 15.5313 27.4531 15.5313C26.6629 15.5354 25.9062 15.8511 25.3474 16.4099C24.7886 16.9687 24.4729 17.7254 24.4688 18.5156V20H20V15.5313H18.5156C17.7254 15.5271 16.9687 15.2114 16.4099 14.6526C15.8511 14.0938 15.5354 13.3371 15.5312 12.5469C15.5313 11.7554 15.8457 10.9963 16.4054 10.4366C16.965 9.87692 17.7241 9.5625 18.5156 9.5625H20V3.59375H36.4063Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M24.4688 27.4531C24.4651 28.2301 24.1601 28.9753 23.618 29.532C23.076 30.0886 22.3391 30.4132 21.5625 30.4375H20V36.4062H3.59375V20H9.5625V21.5625C9.5625 22.354 9.87692 23.1131 10.4366 23.6728C10.9963 24.2325 11.7554 24.5469 12.5469 24.5469C13.3384 24.5469 14.0975 24.2325 14.6571 23.6728C15.2168 23.1131 15.5313 22.354 15.5313 21.5625V20H20V24.4688H21.5625C22.3391 24.493 23.076 24.8176 23.618 25.3743C24.1601 25.9309 24.4651 26.6762 24.4688 27.4531Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M36.4062 20.001V36.4072H20V30.4385H21.5625C22.354 30.4385 23.1131 30.1241 23.6728 29.5644C24.2325 29.0047 24.5469 28.2456 24.5469 27.4541C24.5469 26.6626 24.2325 25.9035 23.6728 25.3438C23.1131 24.7842 22.354 24.4697 21.5625 24.4697H20V20.001H24.4688V18.5166C24.4729 17.7264 24.7886 16.9697 25.3474 16.4109C25.9062 15.8521 26.6629 15.5363 27.4531 15.5322C28.2446 15.5322 29.0037 15.8467 29.5634 16.4063C30.1231 16.966 30.4375 17.7251 30.4375 18.5166V20.001H36.4062Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </svg>
    )
  }),
)

export const IconCamera = memo(
  forwardRef<SVGSVGElement, SVGProps>((props, ref) => {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M12.5469 21.4839C12.5469 22.4626 12.7397 23.4318 13.1142 24.3361C13.4888 25.2403 14.0378 26.062 14.7298 26.754C15.4219 27.4461 16.2436 27.9951 17.1478 28.3697C18.0521 28.7442 19.0212 28.937 20 28.937C20.9788 28.937 21.9479 28.7442 22.8522 28.3697C23.7564 27.9951 24.5781 27.4461 25.2702 26.754C25.9622 26.062 26.5112 25.2403 26.8858 24.3361C27.2603 23.4318 27.4531 22.4626 27.4531 21.4839C27.4531 20.5051 27.2603 19.536 26.8858 18.6317C26.5112 17.7274 25.9622 16.9058 25.2702 16.2137C24.5781 15.5216 23.7564 14.9727 22.8522 14.5981C21.9479 14.2235 20.9788 14.0308 20 14.0308C19.0212 14.0308 18.0521 14.2235 17.1478 14.5981C16.2436 14.9727 15.4219 15.5216 14.7298 16.2137C14.0378 16.9058 13.4888 17.7274 13.1142 18.6317C12.7397 19.536 12.5469 20.5051 12.5469 21.4839Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M27.4532 11.0459L24.4688 6.57715H15.5313L12.5469 11.0459H6.57817C6.18625 11.0459 5.79818 11.1231 5.4361 11.2731C5.07401 11.423 4.74502 11.6429 4.46789 11.92C3.90822 12.4797 3.59379 13.2388 3.59379 14.0303V30.4365C3.59172 30.829 3.6675 31.218 3.81674 31.581C3.96599 31.9441 4.18574 32.2739 4.46328 32.5514C4.74082 32.829 5.07063 33.0487 5.43365 33.1979C5.79667 33.3472 6.18567 33.423 6.57817 33.4209H33.4219C33.8144 33.423 34.2034 33.3472 34.5664 33.1979C34.9294 33.0487 35.2593 32.829 35.5368 32.5514C35.8143 32.2739 36.0341 31.9441 36.1833 31.581C36.3326 31.218 36.4084 30.829 36.4063 30.4365V14.0303C36.4063 13.2388 36.0919 12.4797 35.5322 11.92C34.9725 11.3603 34.2134 11.0459 33.4219 11.0459H27.4532Z"
          stroke="#26231B"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path d="M8.0625 8.06152V11.0459" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M30.4375 15.5322H33.4219" stroke="#26231B" strokeWidth="2" strokeMiterlimit="10" />
      </svg>
    )
  }),
)

export type IconName =
  | "arrowLeft"
  | "arrowRight"
  | "bookmark"
  | "calendar"
  | "cart"
  | "check"
  | "chevronDown"
  | "chevronLeft"
  | "chevronRight"
  | "chevronUp"
  | "close"
  | "download"
  | "hamburger"
  | "info"
  | "location"
  | "placeholder"
  | "play"
  | "add"
  | "account"
  | "search"
  | "selectNo"
  | "selectYes"
  | "ticket"
  | "people-triple-arrows"
  | "diagram"
  | "hands-diamond"
  | "account-arrows"
  | "phone"
  | "chat"
  | "wireless-router"
  | "computer-monitor"
  | "chess-piece"
  | "hand-plant"
  | "puzzle"
  | "camera"

type IconProps = Omit<SVGProps, "name"> & { name: IconRef | undefined }
type IconComponent = (props: SVGProps) => ReactElement
type IconSet = { [K in IconName]: IconComponent }

export const ICONS = {
  arrowLeft: IconArrowLeft,
  arrowRight: IconArrowRight,
  bookmark: IconBookmark,
  calendar: IconCalendar,
  cart: IconCart,
  check: IconCheck,
  chevronDown: IconChevronDown,
  chevronLeft: IconChevronLeft,
  chevronRight: IconChevronRight,
  chevronUp: IconChevronUp,
  close: IconClose,
  download: IconDownload,
  hamburger: IconHamburger,
  info: IconInfo,
  location: IconLocation,
  placeholder: IconPlaceholder,
  play: IconPlay,
  add: IconAdd,
  account: IconAccount,
  search: IconSearch,
  selectNo: IconSelectNo,
  selectYes: IconSelectYes,
  ticket: IconTicket,
  "people-triple-arrows": IconPeopleTripleArrows,
  diagram: IconDiagram,
  "hands-diamond": IconHandsDiamond,
  "account-arrows": IconAccountArrows,
  phone: IconPhone,
  chat: IconChat,
  "wireless-router": IconWirelessRouter,
  "computer-monitor": IconComputerMonitor,
  "chess-piece": IconChessPiece,
  "hand-plant": IconHandPlant,
  puzzle: IconPuzzle,
  camera: IconCamera,
} as IconSet

export type IconRef = IconName | ReactElement

export function Icon(props: IconProps) {
  if (!props.name) return null
  if (isValidElement(props.name)) {
    return props.name
  }
  const { name, ...rest } = props
  if (typeof name === "string" && name in ICONS) {
    const IconComponent = ICONS[name]
    return <IconComponent className="icon" {...rest} />
  }
  return props.name
}
